(function(global) {

	/**
	 * @var boolean モーダルウィンドウが開いているかどうか
	 */
	var modalOpen = false;

	/**
	 * @var integer スクロールX位置
	 */
	var offsetX = 0;

	/**
	 * @var integer スクロールY位置
	 */
	var offsetY = 0;

	/**
	 * @var $
	 */
	var rootE;

	/**
	 * @var $
	 */
	 var bodyE;

	/**
	 * @var $
	 */
	var win;

	$(function() {
		win = $(window);
		bodyE = $(document.body);
		rootE = bodyE.parent();
	});

	/**
	 * @param opened: boolean
	 */
	function setOpen(opened) {
		if (modalOpen === opened) {
			return;
		}
		modalOpen = opened;

		if (!rootE) {
			return;
		}

		if (opened) {
			if (rootE.height() > win.height()) {
				rootE.addClass("modal-open-longpage");
				offsetX = window.scrollX;
				offsetY = window.scrollY;

				// NOTE: 見た目の表示位置をスクロール位置と揃える。IE11では無効
				// 指定しているスタイルは modal-manager.less を参照
				bodyE.css({marginTop: -offsetY, marginLeft: -offsetX});
			}
			rootE.addClass("modal-open");
		} else {
			$("html").removeClass("modal-open modal-open-longpage");
			bodyE.css({marginTop: 0, marginLeft: 0});
			window.scrollTo(offsetX, offsetY);
		}
	}

	global.ModalManager = {
		setOpen: setOpen
	};

})(window);
